import { Map } from 'immutable';
import { constants as authConstants } from '@saucelabs/sl-container-authentication';
import { cookiesHelper } from '@saucelabs/sl-util-helpers';
import { dataCentersList, CURRENT_DC, MULTI_DC_SUPPORT } from '@saucelabs/sl-util-config';

import * as types from './types';

let latestDataCenter = MULTI_DC_SUPPORT && cookiesHelper.getItem(authConstants.LS_LATEST_DC);
const DCValueExists = dataCentersList.find((datacenter) => datacenter.value === latestDataCenter);
if (!latestDataCenter || !DCValueExists) {
  latestDataCenter = CURRENT_DC;
}

const initialState = new Map({
  latestDataCenter,
  loading: true,
});

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case authConstants.UPDATE_DATACENTER: {
      if (payload && payload.dcName) {
        // used purely for UX and preselect latest used value after logout
        cookiesHelper.setItem(authConstants.LS_LATEST_DC, payload.dcName);

        return state.set('latestDataCenter', payload.dcName);
      }
      return state;
    }
    case types.INITIALIZE.SUCCESS:
    case types.INITIALIZE.FAILURE: // It will failure on /api/whoami call for unauthenticated user
      return state.set('loading', false);
    default:
      return state;
  }
};

export default authReducer;
export { initialState };
